import { createFileRoute } from '@tanstack/react-router';
import { UserEmailVerificationForm, useGetViewer } from '@amber-ui/core';

function UserEmailVerificationRoute() {
  const { viewer } = useGetViewer();

  if (!viewer) return null;

  return <UserEmailVerificationForm user={viewer.user} />;
}

export const Route = createFileRoute('/_auth/user/email_verification')({
  component: UserEmailVerificationRoute,
});
